export enum ViewerMode {
  New = 'new',
  Edit = 'edit',
  View = 'view'
};